import { render, staticRenderFns } from "./ActionsContent.vue?vue&type=template&id=ef50cdf8&scoped=true&"
import script from "./ActionsContent.vue?vue&type=script&lang=js&"
export * from "./ActionsContent.vue?vue&type=script&lang=js&"
import style0 from "./ActionsContent.vue?vue&type=style&index=0&id=ef50cdf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef50cdf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabItem,VTabs,VTabsSlider})
